import React from 'react';
import { Box, Text, LinkComponent } from '@rsos/components/capstone/base';
import EmbeddedContainer from '../components/EmbeddedContainer';

const Main = () => {
  return (
    <Box>
      <Box>
        <Text size="header" fontWeight="bold" color="primaryText">
          Responders
        </Text>
      </Box>
      <Box mt={20}>
        <Text size="normal" color="primaryText">
          Automatically notify responders via SMS or email of a train emergency
          in your ECC's jurisdiction. Agencies using IamResponding do not need
          their members added here.
        </Text>
      </Box>
      <Box mt={'8px'}>
        <Text size="small" color="primaryText">
          They will be automatically pre-alerted in the IamResponding app of
          train emergencies that occur within 40 miles of their primary station.
          Learn more about IamResponding (a RapidSOS Company)
          <LinkComponent to="https://www.IamResponding.com">
            here.
          </LinkComponent>
        </Text>
      </Box>
      <Box mt={20}>
        <EmbeddedContainer />
      </Box>
    </Box>
  );
};

export default Main;
